<form [formGroup]="formGroup">
    <div class="grid">
        <div *ngIf="!message" class="col-12 input-field">
            <label for="templateId">Seleccione el documento</label>
            <p-dropdown formControlName="templateId" [options]="templates" optionLabel="name" optionValue="id"
                appendTo="body" [filter]="true" filterBy="name" placeholder="Selecciona un documento"
                (onChange)="onTemplateChange($event)"
                d-form-field-error></p-dropdown>
        </div>

        <div *ngIf="message" class="col-12 input-field">
            {{message}}    
        </div>
    </div>
    <div class="grid" *ngIf="selectedTemplate?.templateConfig?.fields">
        <div *ngFor="let field of selectedTemplate?.templateConfig?.fields" class="input-field {{(field.class!=''?field.class:'col-12')}}">
            <ng-container *ngIf="field.name=='notification_number'">
                <label for="notificationNumberId">{{field.label}}</label>
                <p-dropdown [options]="notificationNumbers" optionLabel="code" optionValue="id"
                    appendTo="body" [filter]="true" filterBy="code" placeholder="Selecciona un número de notificación"
                    [(ngModel)]="notificationNumberId" [ngModelOptions]="{standalone: true}"
                    (onChange)="onSelectNotificationNumber($event)"
                    d-form-field-error></p-dropdown>
                <input *ngIf="notificationNumberId=='-'" pInputText placeholder="introduzca nº servicio" name="{{field.name}}" [(ngModel)]="metadata[field.name]" [ngModelOptions]="{standalone: true}" d-form-field-error />
            </ng-container>
            <ng-container *ngIf="field.name!='notification_number' && field.type=='boolean'">
                <label [for]="field.name">{{field.label}}</label>
                <p-checkbox [inputId]="field.name" [binary]="true" [(ngModel)]="metadata[field.name]"
                    [ngModelOptions]="{standalone: true}"></p-checkbox>
            </ng-container>
            <ng-container *ngIf="field.name!='notification_number' && field.type!='boolean'">
                <label [for]="field.name">{{field.label}}</label>
                <input pInputText name="{{field.name}}" [type]="field.type=='number'?'number':'text'"
                    [(ngModel)]="metadata[field.name]" [ngModelOptions]="{standalone: true}"
                    [readonly]="isFieldDisabled(field)" (ngModelChange)="recomputeFunctions()"
                    d-form-field-error />
            </ng-container>
        </div>
    </div>

    <div *ngIf="!message" class="mt-4 flex gap-2 justify-content-end">
        <p-button *ngIf="templateId" label="Guardar word" icon="pi pi-check" styleClass="p-ml-2" (click)="open('word')"></p-button>
        <div class="flex-grow-i"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" icon="pi pi-check" styleClass="p-ml-2" (click)="open('pdf')"></p-button>
    </div>
    <div *ngIf="message" class="mt-4 fgap-2 justify-content-end">
        <p-button label="Cerrar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
    </div>
</form>